module.exports = ".progress{position:absolute;top:0;left:0;right:0;width:100%;height:5px;z-index:9999}\n"